import { Box, Flex } from '@osmosis/react-ui/components/Box';
import { Button } from '@osmosis/react-ui/components/Button';
import { FormattedMessage } from 'react-intl';
import { QuizItem } from '../../types/quiz';

type QuizActionButtonsProps = {
  isLoading: boolean;
  handleEditQuiz: () => void;
  onStart: (quizItems?: any) => void;
  filteredQuizItems?: QuizItem[];
  showEditButton: boolean;
};

/**
 * Renders the quiz-action buttons.
 */
const QuizActionButtons = ({
  isLoading,
  handleEditQuiz,
  onStart,
  filteredQuizItems,
  showEditButton,
}: QuizActionButtonsProps) => {
  return (
    <Flex sx={{ gap: 3, justifyContent: 'center', padding: 4 }}>
      {showEditButton && (
        <Box>
          <Button
            isLoading={isLoading}
            onClick={handleEditQuiz}
            data-testid="modal-start-edit"
            variant="outline"
          >
            <FormattedMessage
              defaultMessage="Edit Deck"
              id="quiz.edit.button.edit"
            />
          </Button>
        </Box>
      )}
      <Box>
        <Button
          isLoading={isLoading}
          onClick={() => onStart(filteredQuizItems)}
          data-testid="modal-start-button"
        >
          <FormattedMessage
            defaultMessage="Start Deck"
            id="quiz.start_modal.button.start"
          />
        </Button>
      </Box>
    </Flex>
  );
};

export default QuizActionButtons;
